import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';
import BrowserAlertStatus from './BrowserAlertStatus';

function currentRoute() {
  if (typeof window === 'undefined') return '';
  if (window.location.hash.startsWith('#/')) {
    return window.location.hash.slice(1).split('?')[0].replace(/\/+$/, '');
  }
  return window.location.pathname.replace(/\/+$/, '');
}

const GlobalBrowserAlertPrompt = ({ suppress = false }) => {
  const [account, setAccount] = useState(null);
  const [route, setRoute] = useState(currentRoute);

  useEffect(() => {
    let cancelled = false;

    const verifyPaidAccount = async () => {
      const email = (window.localStorage.getItem('userEmail') || '').trim().toLowerCase();
      const accessToken = window.localStorage.getItem('premiumAccessToken') || '';
      if (!email || !accessToken) {
        if (!cancelled) setAccount(null);
        return;
      }

      try {
        const response = await axios.get(`${API_BASE_URL}/api/subscription-status`, {
          params: { email },
          headers: { 'x-premium-access-token': accessToken },
        });
        const payload = response?.data || {};
        const paid = Boolean(payload.subscription?.paid ?? payload.paid);
        if (paid && payload.access_token) {
          window.localStorage.setItem('premiumAccessToken', payload.access_token);
        }
        if (!cancelled) setAccount(paid ? { email } : null);
      } catch (error) {
        if (!cancelled) setAccount(null);
      }
    };

    const refreshRouteAndAccount = () => {
      setRoute(currentRoute());
      verifyPaidAccount();
    };

    verifyPaidAccount();
    window.addEventListener('hashchange', refreshRouteAndAccount);
    window.addEventListener('popstate', refreshRouteAndAccount);
    window.addEventListener('storage', refreshRouteAndAccount);
    window.addEventListener('premium-access-changed', refreshRouteAndAccount);
    window.addEventListener('focus', verifyPaidAccount);

    return () => {
      cancelled = true;
      window.removeEventListener('hashchange', refreshRouteAndAccount);
      window.removeEventListener('popstate', refreshRouteAndAccount);
      window.removeEventListener('storage', refreshRouteAndAccount);
      window.removeEventListener('premium-access-changed', refreshRouteAndAccount);
      window.removeEventListener('focus', verifyPaidAccount);
    };
  }, []);

  const checkoutRoutes = ['/pricing', '/payment-success', '/payment-failure', '/premium-access'];
  if (suppress || !account || checkoutRoutes.includes(route) || route === '/tools' || route.startsWith('/tools/')) return null;

  return (
    <aside className="global-browser-alert-prompt" aria-label="Browser alert enrollment">
      <BrowserAlertStatus paid email={account.email} compact />
    </aside>
  );
};

export default GlobalBrowserAlertPrompt;
